export interface ZoomToggleLabels {
  on: string
  off: string
}

export const DEFAULT_ZOOM_TOGGLE_LABELS: ZoomToggleLabels = {
  on: 'Disable zoom',
  off: 'Enable zoom',
}
